<template>
  <modal class="q-modal poe-schedule-item" name="poe-schedule-modal" :class="ifTop"
       transition="nice-modal-fade"
       :width="800"
       :min-width="800"
       :height="'auto'"
       :delay="100"
       :draggable="'.modal-header'"
       :clickToClose="false"
       :adaptive="true"
       @opened="Opened"
       classes='q-v--modal'>
    <div class="modal-content" @mouseup="onScheduleMouseup">
      <div class="modal-header">
        {{$t('poe.title')}}
      </div>
      <div class="icon-btn_close modal-close" @click="onClose()"></div>
      <scrollbar ref="scrollbar" class="scrollbar-body">
        <div class="modal-body">
          <div class="modal-container">
            <div class="form">
              <div class="formRow">
                <span class="title">{{$t('vlan.ports')}}</span>
                <span class="forminput">{{selectedList | getPort}}</span>
              </div>
              <div class="formRow">
                <div class="port-members">{{$t('poe.applyTo')}}</div>
                <div class="formlabel fontB subitem select-all" @click="onSelection('all')">
                    <checkbox class="q-checkbox-label" style="display: table-row" :checked="isAll" :label="$t('all')"></checkbox>
                </div>
                <div class="forminput">
                  <div class="port-select top">
                    <table>
                      <tr class="table-header">
                        <td style="width:20%;">{{$t('poe.port', '')}}</td>
                        <td style="width:4%;" v-for="num in portNumber" :key="num" >{{num}}</td>
                      </tr>
                      <tr class="table-body">
                        <td class="table-body-content" style="width:20%;">{{$t('selected')}}</td>
                        <td class="table-body-content" style="width:4%;" v-for="num in portNumber" :key="num" :title="getTips(num)">
                          <div class="formlabel fontB subitem" @click="onSelection(num)">
                              <checkbox class="q-checkbox-label" :checked="isItemChecked(num)" :disabled="getDisable(num)"></checkbox>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
              <div class="formRow schedule">
                <div class="title">{{$t('poe.schedule')}}</div>
                <table class="schedule-table">
                  <tr class="table-header">
                    <td style="width:4%;text-align:center;">{{$t('menu.systime')}}</td>
                    <td style="width:4%;text-align:right;" v-for="num in 24" :key="num">{{num}}</td>
                  </tr>
                  <tr class="table-body" v-for="num in 7" :key="num">
                    <td class="table-body-content title" style="width:4%;">{{getWeekName(num)}}</td>
                    <td ref="weekItem" class="table-body-content schedule-item" :class="getIdName(num, time)" style="width:4%;" v-for="time in 24" :key="time" @mousedown="onScheduleMousedown" @mouseenter="onScheduleMousemove" :id="getIdName(num) + '_' + time">
                    </td>
                  </tr>
                </table>
                <div class="legend-content">
                  <div class="legend on"></div><span>{{$t('on')}}</span>
                  <div class="legend"></div><span>{{$t('off')}}</span>
                </div>
                <div class="formlabel fontB subitem select-all" @click="onSelection('turnOn')">
                    <checkbox class="q-checkbox-label " style="display: table-row" :checked="isTurnOnNow" :label="$t('poe.turnOn')"></checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </scrollbar>
      <div class="modal-footer">
        <div class="footer-left">
        </div>
        <div class="footer-right">
          <button class="q-button" @click="onSaveClick()" :disabled="!enableBtn">{{$t('save')}}</button>
          <button class="q-button cancel" @click="onClose()">{{$t('cancel')}}</button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import checkbox from './module/Checkbox'
export default {
  name: 'PoeScheduleItem',
  props: {
    selectItem: Object,
    isEanble: Boolean,
    onChange: Function
  },
  components: {
    checkbox
  },
  data () {
    return {
      modalname: 'poe-schedule-modal',
      showModal: true,
      portId: null,
      selectedList: [],
      isAll: false,
      enableBtn: false,
      ifDrag: false,
      currentDate: null,
      isCancelSchedule: false,
      isTurnOnNow: false,
      scheduleList: [],
      arrayFlag: [null, '0'],
      schedule: {},
      preventId: 0
    }
  },
  filters: {
    getPort: function (value) {
      return value.join(', ')
    }
  },
  watch: {
    selectItem: function (value) {
      let data = value.data
      this.selectedList = []
      this.portId = parseInt(data.key)
      this.schedule = data.val
      this.selectedList.push(this.portId)
      if (this.selectItem.data.val.Schedule.length > 0) {
        let start = []
        let end = []
        let j = 0
        let me = this
        this.selectItem.data.val.Schedule.forEach(res => {
          if (res.Time) {
            res.Time.forEach(element => {
              let char = element.split('-')
              if (parseInt(char[0]) < parseInt(char[1])) {
                start.push(parseInt(char[0]))
                end.push(parseInt(char[1]))
              }
            })
          }
          for (let i = 0; i < 25; i++) {
            if (i >= start[j] && i < end[j]) {
              me.scheduleList[parseInt(res.Week)][i + 1] = 1
            }
            if (i >= end[j]) j++
          }
          j = 0
          start = []
          end = []
        })
      }
      this.isTurnOnNow = value.isEnable
      this.getDisable()
    }
  },
  created () {
    this.scheduleList = new Array(7).fill(0)
    this.scheduleList = this.scheduleList.map(() => Array(25).fill(0))
  },
  methods: {
    ...mapMutations([
      'openModal',
      'closeModal'
    ]),
    Opened (event) {
      const modal = document.querySelector('.v--modal-box.q-v--modal')
      let height = document.body.clientHeight
      let modalH = this.$el.getElementsByClassName('q-v--modal')[0].offsetHeight
      let winWidth = document.body.clientWidth
      let tempW = (winWidth > 800) ? 800 : winWidth - 90
      if (modalH > height && modal) {
        modal.style.height = (height - 90) + 'px'
        modal.style.top = 'calc(50% - ' + ((height - 90) / 2) + 'px'
      }
      if (modal) {
        modal.style.width = tempW + 'px'
        modal.style.left = 'calc(50% - ' + (tempW / 2) + 'px'
      }
      this.$refs.scrollbar.onResize()
    },
    setInitial: function () {
      this.enableBtn = false
      this.arrayFlag = [null, '0']
      this.scheduleList = new Array(7).fill(0)
      this.scheduleList = this.scheduleList.map(() => Array(25).fill(0))
      this.preventId = 0
      this.isAll = false
    },
    getDisable: function (port) {
      return (port === this.portId || this.setPoEdisabled(port))
    },
    isItemChecked: function (item) {
      let index = this.selectedList.indexOf(item)
      return (index > -1)
    },
    onSelection: function (item) {
      if (item === 'all') {
        this.isAll = !this.isAll
        if (this.isAll) {
          let temp = []
          for (let i = 1; i < this.portNumber + 1; i++) {
            if (!this.setPoEdisabled(i)) {
              temp.push(i)
            }
          }
          this.selectedList = temp
        } else {
          this.selectedList = []
          this.selectedList.push(this.portId)
        }
        this.enableBtn = true
      } else if (item === 'turnOn') {
        this.isTurnOnNow = !this.isTurnOnNow
        this.enableBtn = true
      } else {
        if (!this.setPoEdisabled(item)) {
          if (this.portId !== item) {
            let index = this.selectedList.indexOf(item)
            if (index > -1) {
              this.selectedList.splice(index, 1)
            } else {
              this.selectedList.push(item)
            }
            let checkIsAll = true
            for (let i = 1; i < this.portNumber + 1; i++) {
              if (!this.setPoEdisabled(i) && !this.selectedList.includes(i)) {
                checkIsAll = false
                break
              }
            }
            this.isAll = checkIsAll
          }
          this.enableBtn = true
        }
      }
      this.selectedList.sort(function (a, b) {
        return a - b
      })
    },
    onScheduleMousedown: function (event) {
      let isSelect = event.target.classList.contains('selected')
      let week = event.target.id.split('_')[0]
      let id = parseInt(event.target.id.split('_')[1])
      this.ifDrag = true
      this.currentDate = week
      if (!isSelect) {
        this.isCancelSchedule = false
      } else {
        this.isCancelSchedule = true
      }
      if (this.ifDrag) {
        document.body.style.cursor = 'pointer'
        this.preventId = id
        let item = document.getElementById(event.target.id)
        if (isSelect) {
          item.classList.remove('selected')
        } else {
          item.classList.add('selected')
        }
      }
    },
    onScheduleMousemove: function (event) {
      let item = document.getElementById(event.target.id)
      // let week = event.target.id.split('_')[0]
      // let id = parseInt(event.target.id.split('_')[1])
      if (this.ifDrag) {
        if (this.isCancelSchedule) {
          item.classList.remove('selected')
        } else {
          item.classList.add('selected')
        }
        // if (week === this.currentDate) {
        //   if ((id === this.preventId + 1) || (id === this.preventId - 1)) {
        //     if (this.isCancelSchedule) {
        //       item.classList.remove('selected')
        //     } else {
        //       item.classList.add('selected')
        //     }
        //     this.preventId = id
        //   } else {
        //     event.preventDefault()
        //     this.ifDrag = false
        //     document.body.style.cursor = 'default'
        //   }
        // }
      }
    },
    onScheduleMouseup: function (event) {
      this.ifDrag = false
      document.body.style.cursor = 'inherit'
      this.enableBtn = true
    },
    getIdName: function (dstWeek, time) {
      let name = ''
      switch (dstWeek) {
        case 1:
          name = 'Mon'
          break
        case 2:
          name = 'Tue'
          break
        case 3:
          name = 'Wed'
          break
        case 4:
          name = 'Thu'
          break
        case 5:
          name = 'Fri'
          break
        case 6:
          name = 'Sat'
          break
        case 7:
          name = 'Sun'
          break
      }
      if (time && this.scheduleList.length > 0) {
        if (dstWeek > 6) dstWeek = 0
        if (this.scheduleList[dstWeek][time] === 1) {
          name = name + ' selected'
        }
        // for (const key in this.schedule) {
        //   const element = this.schedule[key]
        //   let tempweek = ((7 - element.day) === 7) ? 7 : element.day
        //   if (dstWeek === tempweek) {
        //     if ((time - 1 >= element.start_at) && time <= element.start_at + element.duration) {
        //       name = name + ' selected'
        //     }
        //   }
        // }
      }
      return name
    },
    getWeekName: function (dstWeek) {
      let name = ''
      switch (dstWeek) {
        case 1:
          name = this.$t('dstWeek.mon')
          break
        case 2:
          name = this.$t('dstWeek.tue')
          break
        case 3:
          name = this.$t('dstWeek.wed')
          break
        case 4:
          name = this.$t('dstWeek.thu')
          break
        case 5:
          name = this.$t('dstWeek.fri')
          break
        case 6:
          name = this.$t('dstWeek.sat')
          break
        case 7:
          name = this.$t('dstWeek.sun')
          break
      }
      return name
    },
    getScheduleSelect: function () {
      let scheduleItem = this.$getElementsByClassName(document, 'schedule-item')
      let id = null
      for (const key in scheduleItem) {
        if (scheduleItem.hasOwnProperty(key)) {
          const element = scheduleItem[key]
          id = element.id.split('_')
          if (element.classList.contains('selected')) {
            this.pushList(id)
          } else {
            this.delList(id)
          }
        }
        // if (key === 'length') {
        //   if (!this.scheduleList[this.arrayFlag[0]]) {
        //     this.scheduleList[this.arrayFlag[0]] = []
        //   }
        //   this.scheduleList[this.arrayFlag[0]].push(tempArr)
        //   return this.changeFormat(this.scheduleList)
        // }
      }
    },
    pushList (id) {
      let start = (parseInt(id[1]))
      // let end = parseInt(id[1])
      switch (id[0]) {
        case 'Mon' :
          this.scheduleList[1][start] = 1
          // this.scheduleList[1][end] = 1
          break
        case 'Tue' :
          this.scheduleList[2][start] = 1
          // this.scheduleList[2][end] = 1
          break
        case 'Wed' :
          this.scheduleList[3][start] = 1
          // this.scheduleList[3][end] = 1
          break
        case 'Thu' :
          this.scheduleList[4][start] = 1
          // this.scheduleList[4][end] = 1
          break
        case 'Fri' :
          this.scheduleList[5][start] = 1
          // this.scheduleList[5][end] = 1
          break
        case 'Sat' :
          this.scheduleList[6][start] = 1
          // this.scheduleList[6][end] = 1
          break
        case 'Sun' :
          this.scheduleList[0][start] = 1
          // this.scheduleList[0][end] = 1
          break
      }
    },
    delList (id) {
      let end = parseInt(id[1])
      switch (id[0]) {
        case 'Mon' :
          this.scheduleList[1][end] = 0
          break
        case 'Tue' :
          this.scheduleList[2][end] = 0
          break
        case 'Wed' :
          this.scheduleList[3][end] = 0
          break
        case 'Thu' :
          this.scheduleList[4][end] = 0
          break
        case 'Fri' :
          this.scheduleList[5][end] = 0
          break
        case 'Sat' :
          this.scheduleList[6][end] = 0
          break
        case 'Sun' :
          this.scheduleList[0][end] = 0
          break
      }
    },
    changeFormat: function (data) {
      let val = []
      if (data['Mon']) {
        data['Mon'].forEach(element => {
          val.push({
            day: 1,
            start_at: parseInt(element[0]) - 1,
            duration: element.length
          })
        })
      }
      if (data['Tue']) {
        data['Tue'].forEach(element => {
          val.push({
            day: 2,
            start_at: parseInt(element[0]) - 1,
            duration: element.length
          })
        })
      }
      if (data['Wed']) {
        data['Wed'].forEach(element => {
          val.push({
            day: 3,
            start_at: parseInt(element[0]) - 1,
            duration: element.length
          })
        })
      }
      if (data['Thu']) {
        data['Thu'].forEach(element => {
          val.push({
            day: 4,
            start_at: parseInt(element[0]) - 1,
            duration: element.length
          })
        })
      }
      if (data['Fri']) {
        data['Fri'].forEach(element => {
          val.push({
            day: 5,
            start_at: parseInt(element[0]) - 1,
            duration: element.length
          })
        })
      }
      if (data['Sat']) {
        data['Sat'].forEach(element => {
          val.push({
            day: 6,
            start_at: parseInt(element[0]) - 1,
            duration: element.length
          })
        })
      }
      if (data['Sun']) {
        data['Sun'].forEach(element => {
          val.push({
            day: 0,
            start_at: parseInt(element[0]) - 1,
            duration: element.length
          })
        })
      }
      this.$log.debug(val)
      return val
    },
    onSaveClick: function () {
      this.enableBtn = false
      this.getScheduleSelect()
      let scheduleData = []
      let timeData = []
      let weekData = []
      for (let j = 0; j < 7; j++) {
        let sum = this.scheduleList[j].reduce((partialSum, a) => partialSum + a, 0)
        if (sum >= 1) {
          let start = -1
          let end = -1
          for (let k = 1; k < 25; k++) {
            if ((k === 1 && this.scheduleList[j][k] === 1) || (this.scheduleList[j][k] === 1 && this.scheduleList[j][k - 1] === 0)) {
              start = k
            }
            if ((k === 24 && this.scheduleList[j][k] === 1) || (this.scheduleList[j][k] === 1 && this.scheduleList[j][k + 1] === 0)) {
              end = k
            }
            if (start > -1 && end > -1) {
              timeData.push((start - 1) + '-' + end)
              start = -1
              end = -1
            }
          }
          if (timeData.length > 0) {
            weekData.push({
              Time: timeData,
              Week: j
            })
            timeData = []
          }
        }
      }
      for (let i = 0; i < this.selectedList.length; i++) {
        let port = this.selectedList[i]
        scheduleData.push({
          key: port.toString(),
          val: {
            Enable: this.isTurnOnNow,
            Schedule: weekData
          }
        })
      }
      this.setPoeSchedule(scheduleData).then((res) => {
        this.onChange()
        this.onClose()
      })
    },
    onOpen () {
      this.openModal(this.modalname)
      this.$modal.show(this.modalname)
    },
    onClose () {
      this.setInitial()
      this.closeModal(this.modalname)
      this.$modal.hide(this.modalname)
    },
    setPoEdisabled: function (key) {
      if (key > 8) return true
      return false
    },
    getTips: function (key) {
      let tips = ''
      if (this.setPoEdisabled(key)) {
        tips = this.$t('poe.notSup')
      }
      return tips
    },
    ...mapActions(['setPoeSchedule'])
  },
  computed: {
    ...mapState({
      portNumber: state => state.module.portNum
    }),
    ...mapGetters(['getTopModalName']),
    ifTop () {
      this.$log.debug('this.getTopModalName :' + this.getTopModalName)

      if (this.getTopModalName !== this.modalname) {
        return 'noTopModal'
      } else {
        return 'none'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';

@import '../assets/scss/modal.scss';

.poe-schedule-item {
  user-select: none;
  .modal-container {
    .formRow {
      margin-bottom: 10px;
      .privateIdInput {
        width: 100px;
      }
      .forminput {
        margin: 0px 10px;
        .port-select {
          margin-top: 10px;
          >table {
            margin-top: 8px;
            width: 100%;
            text-align: center;
            td {
              border: 1px solid #F1F1F1;
              .q-checkbox-label {
                display: inline-block;
                margin: auto;
              }
            }
            .table-header {
              background: #F2F3F8;
              height: 28px;
              text-align: center;
            }
            .table-body {
              height: 38px;
            }
          }
        }
      }
      .schedule-table {
        margin-top: 10px;
        .table-body {
          .table-body-content {
            border: 1px solid #F1F1F1;
            background: none;
            height: 30px;
            &.title {
              padding: 0px 20px;
            }
            &.selected {
              background: #CDE4FE;
              border: none;
            }
          }
        }
      }
      .select-all {
        margin-top: 10px;
      }
      &.schedule {
        margin-top: 20px;
        margin-bottom: 0px;
        .legend-content {
          margin-top: 10px;
          display: flex;
          justify-content: flex-end;
          .legend {
            width: 18px;
            height: 18px;
            border: 1px solid #000;
            display: inline-block;
            margin-right: 5px;
            &.on {
              background: #CDE4FE;
            }
          }
          span {
            margin-right: 5px;
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/PoeScheduleItem.vue